import { AudiencePage } from "../components/AudiencePage";
import { AUDIENCE_PAGES } from "../data/content";

export const Privat = () => <AudiencePage data={AUDIENCE_PAGES.privat} pageId="privat" />;
export const Unternehmen = () => <AudiencePage data={AUDIENCE_PAGES.unternehmen} pageId="unternehmen" />;
export const Kommunen = () => <AudiencePage data={AUDIENCE_PAGES.kommunen} pageId="kommunen" />;
